import { Box, FormLabel, Link, Tooltip, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface AppFieldViewProps {
	label?: string;
	labelElement?: React.ReactNode;
	valueElement?: React.ReactNode;
	value?: string;
	subValue?: string;
	editButton?: React.ReactNode;
	link?: string;
}

export default function AppFieldView({
	label,
	labelElement,
	valueElement,
	value,
	subValue,
	link,
	editButton,
}: AppFieldViewProps) {
	return (
		<>
			<AppFormLabel>
				<span style={{ color: '#646D11' }}>{label}</span>
				{labelElement && labelElement}
			</AppFormLabel>
			<Box display='flex' alignItems='center' sx={{ minHeight: '1.5em' }}>
				<Typography
					variant='body1'
					sx={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
				>
					{valueElement ? (
						<>{valueElement}</>
					) : link ? (
						value === undefined || value === '' ? (
							''
						) : (
							<Link href={link} target='_blank' color='#1BBED7'>
								{value}
							</Link>
						)
					) : (
						<>{value === undefined || value === '' ? '' : value}</>
					)}
					{subValue && (
						<Typography
							variant='body2'
							color='common.neutral50'
							display='inline-block'
						>
							{subValue}
						</Typography>
					)}
				</Typography>

				{editButton && <>{editButton}</>}
			</Box>
		</>
	);
}

export function AppFormLabel({ children }: { children: ReactNode }) {
	return <FormLabel sx={{ fontSize: '12px' }}>{children}</FormLabel>;
}
